import { Descriptions, Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";

function DescriptionView() {
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  const items1 = [
    {
      key: "1",
      label: "Job Title",
      children: activeObjJob?.jobTitle ?? "N/A",
    },
    {
      key: "2",
      label:
        "Briefly describe what the job entails and specify the job requirements.",
      children: (
        <div
          dangerouslySetInnerHTML={{
            __html: activeObjJob?.jobBrief || "N/A",
          }}
        />
      ),
    },
    {
      key: "3",
      label: "Job requirements",
      children: (
        <div
          dangerouslySetInnerHTML={{
            __html: activeObjJob?.jobRequirements || "N/A",
          }}
        />
      ),
    },
    {
      key: "4",
      label: "Job responsibilities",
      children: (
        <div
          dangerouslySetInnerHTML={{
            __html: activeObjJob?.jobResponsibilities || "N/A",
          }}
        />
      ),
    },
  ];
  return (
    <div className="">
      <div className="text-[#0B363D] font-[600] text-[1.5rem] font-dmSans">
        1. Job Description
      </div>
      <div className="mt-[1rem] mb-[1.5rem]">
        <Divider />
      </div>

      <Descriptions
        title=""
        column={1}
        colon={false}
        items={items1}
        layout="vertical"
      />
    </div>
  );
}

export default DescriptionView;
